import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Label,
  Input,
} from "reactstrap";
import { useFormik } from "formik";
import axiosInstance from "../axiosInterceptor";
import { toast } from "react-toastify";
import {
  brandSchema,
  currencyschema,
  HandlerSchema,
  ImportCurrencySchema,
  menuImageSchema,
  Permissionschema,
  ShippingPartnerSchema,
  shippingRateSchema,
  shippingZoneSchema,
} from "../Schema/Schema";
import Select from "react-select";
import { COUNTRIES } from "../Data/CountryList";
import makeAnimated from "react-select/animated";
import Upload from "../Components/upload";
import { SwitchToggle } from "../helper/ImageFormat";
import { selectStyles } from "../utils/selectStyles";
const animatedComponents = makeAnimated();

const CurrencyModal = ({
  modalOpen,
  toggleModal,
  editingId,
  fetchCurrencies,
  updatedata,
  setEditingId,
  setupdatedata,
}) => {
  const [loading, setLoading] = useState(false);

  const initialValues = {
    code: "",
    symbol: "",
    rate: "",
    flag: "",
    isActive: true,
  };

  const {
    errors,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    touched,
  } = useFormik({
    initialValues,
    validationSchema: currencyschema,
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);
      try {
        const response = editingId
          ? await axiosInstance.put(`/currency/${editingId}`, values)
          : await axiosInstance.post("/currency", values);

        if (response.status === 200) {
          fetchCurrencies();
          toggleModal();
          toast.success(response?.data?.message);
          resetForm();
          setEditingId(null);
          setupdatedata(null);
        }
      } catch (err) {
        toast.error(err?.response?.data?.message);
      } finally {
        setLoading(false);
      }
    },
  });

  useEffect(() => {
    if (updatedata) {
      setFieldValue("code", updatedata?.code || "");
      setFieldValue("symbol", updatedata?.symbol || "");
      setFieldValue("rate", updatedata?.rate || "");
      setFieldValue("flag", updatedata?.flag || "");
      setFieldValue("isActive", updatedata?.isActive ?? true);
    }
  }, [editingId, updatedata, setFieldValue]);

  return (
    <Modal
      isOpen={modalOpen}
      toggle={toggleModal}
      centered
      className="white-modal"
      size="md"
    >
      <ModalHeader toggle={toggleModal}>
        {editingId ? "Update Currency" : "Add Currency"}
      </ModalHeader>
      <form onSubmit={handleSubmit}>
        <ModalBody>
          <div className="row" style={{ marginTop: "-20px" }}>
            <div className="col-md-6 mb-3">
              <Label htmlFor="code" className="form-label fw-bold">
                Currency Code
              </Label>
              <Input
                type="text"
                name="code"
                id="code"
                placeholder="Enter code (e.g. USD)"
                className={` border border-dark form-control form-control-sm ${touched.code && errors.code ? "is-invalid" : ""}`}
                value={values.code}
                onChange={(e) => {
                  const upperCaseValue = e.target.value.toUpperCase();
                  setFieldValue("code", upperCaseValue);
                }}
                onBlur={handleBlur}
              />
              {touched.code && errors.code && (
                <div className="invalid-feedback">{errors.code}</div>
              )}
            </div>



            <div className="col-md-6 mb-3">
              <Label htmlFor="symbol" className="form-label fw-bold">
                Symbol
              </Label>
              <Input
                type="text"
                name="symbol"
                id="symbol"
                placeholder="Enter symbol (e.g. $)"
                className={`border border-dark form-control form-control-sm ${touched.symbol && errors.symbol ? "is-invalid" : ""}`}
                value={values.symbol}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              {touched.symbol && errors.symbol && (
                <div className="invalid-feedback">{errors.symbol}</div>
              )}
            </div>

            <div className="col-md-6">
              <Label htmlFor="rate" className="form-label fw-bold">
                Conversion Rate
              </Label>
              <Input
                type="number"
                name="rate"
                id="rate"
                placeholder="Enter conversion rate"
                className={` border border-dark form-control form-control-sm ${touched.rate && errors.rate ? "is-invalid" : ""}`}
                value={values.rate}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              {touched.rate && errors.rate && (
                <div className="invalid-feedback">{errors.rate}</div>
              )}
            </div>

            <div className="col-md-6 mt-3">
              <label className="form-label fw-bold"> Upload Flag</label>
              <Upload
                label="currency-flag"
                initialImage={values.flag}
                onChange={(imgUrl) => setFieldValue("flag", imgUrl)}
                apiUrl={"uploads?label=currency"}

              />
            </div>

            <div className="col-md-12 mt-4">
              <SwitchToggle
                checked={values.isActive}
                onChange={(val) => setFieldValue("isActive", val)}
                activeLabel="Active"
                inactiveLabel="Inactive"
              />
            </div>


          </div>
        </ModalBody>
        <ModalFooter>
          <Button type="submit" color="primary" disabled={loading}>
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Saving...
              </>
            ) : editingId ? (
              "Update"
            ) : (
              "Add"
            )}
          </Button>
          <Button color="danger" onClick={toggleModal}>
            Cancel
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};
export const ImportExcellModal = ({
  modalOpen,
  toggleModal,
  fetchdata,
  apiUrl,
  Heading,
}) => {
  const [loading, setLoading] = useState(false);
  const initialValues = {
    csv: "",
  };

  const { handleSubmit, setFieldValue, errors, touched } = useFormik({
    initialValues,
    validationSchema: ImportCurrencySchema,
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);
      try {
        const formData = new FormData();
        formData.append("csv", values.csv);

        const response = await axiosInstance.post(apiUrl, formData);

        if (response.status === 200) {
          fetchdata();
          toggleModal();
          toast.success(response?.data?.message);
          resetForm();
        }
      } catch (err) {
        toast.error(err?.response?.data?.message);
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <Modal
      isOpen={modalOpen}
      toggle={toggleModal}
      centered
      className="white-modal"
    >
      <ModalHeader toggle={toggleModal}>{Heading}</ModalHeader>
      <form onSubmit={handleSubmit}>
        <ModalBody>
          <div className="row" style={{ marginTop: "-20px" }}>
            <div className="col-12">
              <Label htmlFor="csv" className="form-label fw-bold">
                Upload File
              </Label>
              <Input
                type="file"
                name="csv"
                id="csv"
                accept=".csv"
                onChange={(e) => {
                  const file = e.target.files[0];
                  setFieldValue("csv", file);
                }}
                className={`border border-dark  form-control ${touched.csv && errors.csv ? "is-invalid" : ""}`}
              />
              {touched.csv && errors.csv && (
                <div className="text-danger mt-1">{errors.csv}</div>
              )}
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button type="submit" color="primary" disabled={loading}>
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Saving...
              </>
            ) : (
              "Add"
            )}
          </Button>
          <Button color="danger" onClick={toggleModal}>
            Cancel
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};
const ShippingzoneModel = ({
  modalOpen,
  toggleModal,
  editingId,
  fetchApi,
  updatedata,
  setEditingId,
  setupdatedata,
}) => {
  const [loading, setLoading] = useState(false);
  const initialValues = {
    name: "",
    countries: [],
  };
  const {
    errors,
    values,
    touched,
    setFieldValue,
    handleBlur,
    handleChange,
    handleSubmit,
  } = useFormik({
    initialValues,
    validationSchema: shippingZoneSchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const response = editingId
          ? await axiosInstance.put(`/shipping/zone/${editingId}`, values)
          : await axiosInstance.post("/shipping/zone", values);

        if (response.status === 200) {
          fetchApi();
          toggleModal();
          toast.success(response?.data?.message);
          setEditingId(null);
          setupdatedata(null);
        }
      } catch (err) {
        toast.error(err.response?.data?.message);
        return err.response?.data?.message;
      } finally {
        setLoading(false);
      }
    },
  });

  useEffect(() => {
    if (updatedata) {
      setFieldValue("name", updatedata?.name || "");
      setFieldValue("countries", updatedata?.countries || []);
    }
  }, [editingId, updatedata, setFieldValue]);

  const countriesOption = COUNTRIES.map(({ label, value }) => ({
    label,
    value: label,
    code: value,
  }));

  return (
    <Modal
      isOpen={modalOpen}
      toggle={toggleModal}
      centered
      className="white-modal"
    >
      <ModalHeader toggle={toggleModal} className="close-currency">
        <div style={{ fontFamily: "'Poppins', sans-serif" }}>
          {editingId ? "Update" : "Add"} shipping zone
        </div>
      </ModalHeader>
      <form onSubmit={handleSubmit}>
        <ModalBody className="currency">
          <div className="mb-3">
            <input
              type="text"
              name="name"
              id="name"
              placeholder="Enter name"
              value={values.name}
              onChange={handleChange}
              className={`form-control form-control-sm border border-dark`}
            />

            {touched.name && errors?.name && (
              <small className="text-danger">{errors.name}</small>
            )}
          </div>

          <div className="mb-3">
            <Select
              closeMenuOnSelect={false}
              components={animatedComponents}
              isMulti
              styles={selectStyles}
              options={countriesOption}
              onChange={(selectedOptions) =>
                setFieldValue(
                  "countries",
                  selectedOptions.map((option) => option.value)
                )
              }
              onBlur={handleBlur}
              value={countriesOption.filter((option) =>
                values.countries.includes(option.value)
              )}
              getOptionLabel={(e) => (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={`https://flagcdn.com/w20/${e?.code?.toLowerCase()}.png`}
                    alt=""
                    style={{ width: 20, height: 15, marginRight: 10 }}
                  />
                  {e.label}
                </div>
              )}
            />

            {touched.countries && errors?.countries && (
              <small className="text-danger">{errors.countries}</small>
            )}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button type="submit" color="primary" disabled={loading}>
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Saving...
              </>
            ) : editingId ? (
              "Update"
            ) : (
              "Add"
            )}
          </Button>
          <Button color="danger" onClick={toggleModal}>
            Cancel
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};
const ShippingRateModel = ({
  modalOpen,
  toggleModal,
  editingId,
  fetchApi,
  updatedata,
  setEditingId,
  setupdatedata,
  expandedRow,
}) => {
  const [showCondition, setShowCondition] = useState(false);

  const initialValues = {
    name: "",
    type: "",
    price: null,
    maxWeight: null,
    minWeight: null,
    minprice: null,
    maxprice: null,
    description: "",
    selectedOption: "",
  };
  const {
    errors,
    values,
    touched,
    setFieldValue,
    handleBlur,
    handleChange,
    handleSubmit,
  } = useFormik({
    initialValues,
    validationSchema: shippingRateSchema,
    onSubmit: async (values) => {
      try {
        values.zone_id = expandedRow;
        if (values.selectedOption === "WEIGHT") {
          values.minprice = null;
          values.maxprice = null;
        }
        if (values.selectedOption === "TOTAL_PRICE") {
          values.minWeight = null;
          values.maxWeight = null;
        }

        if (!showCondition) values.selectedOption = null;
        const response = editingId
          ? await axiosInstance.put(`/shipping/rate/${editingId}`, values)
          : await axiosInstance.post("/shipping/rate", values);

        if (response.status === 200) {
          fetchApi();
          toggleModal();
          toast.success(response?.data?.message);
          setEditingId(null);
          setupdatedata(null);
        }
      } catch (err) {
        toast.error(err.response?.data?.message);
        return err.response?.data?.message;
      }
    },
  });

  useEffect(() => {
    if (updatedata) {
      setFieldValue("name", updatedata?.name || "");
      setFieldValue("type", updatedata?.type || "");
      setFieldValue("price", updatedata?.price || "");
      setFieldValue("minWeight", updatedata?.minWeight || null);
      setFieldValue("maxWeight", updatedata?.maxWeight || null);
      setFieldValue("minprice", updatedata?.minprice || null);
      setFieldValue("maxprice", updatedata?.maxprice || null);
      setFieldValue("description", updatedata?.description || null);
      setFieldValue("selectedOption", updatedata?.selectedOption || null);
    }
  }, [editingId, updatedata, setFieldValue]);

  const typeOption = [
    { value: "FLAT_RATE", label: "Flat Rate" },
    { value: "EXCEL_SHEET", label: "Excel Sheet" },
  ];

  return (
    <Modal
      isOpen={modalOpen}
      toggle={toggleModal}
      centered
     className="white-modal"
      style={{ maxWidth: "600px", width: "80%" }}
    >
      <ModalHeader toggle={toggleModal} className="shipping-rate">
        <div style={{ fontFamily: "'Poppins', sans-serif" }}>
          {editingId ? "Update" : "Add"} shipping Rate
        </div>
      </ModalHeader>
      <form onSubmit={handleSubmit} >
        <ModalBody className="shipping-rate">
          <div className="d-flex flex-row w-100" style={{ gap: "1rem" }}>
            <div className="mb-2 w-100">
              <Select
              styles={selectStyles}
                closeMenuOnSelect={true}
                options={typeOption}
                placeholder="Select type"
                className="w-100"
                classNamePrefix="react-select"
                onChange={(selectedOption) =>
                  setFieldValue("type", selectedOption.value)
                }
                onBlur={handleBlur}
                value={typeOption.find((option) => option.value === values.type)}
              />
            </div>
            <div className="mb-2 w-100">
              <input
                type="text"
                name="name"
                id="name"
                placeholder="Enter name"
                value={values.name}
                onChange={handleChange}
                className="form-control form-control-sm w-100 border border-dark"
              />
              {touched.name && errors?.name && (
                <small className="text-danger">{errors.name}</small>
              )}
            </div>
          </div>

          <div className="d-flex flex-row w-100" style={{ gap: "1rem" }}>
            <div className="mb-2 w-100">
              <input
                type="number"
                name="price"
                id="price"
                placeholder="Enter price"
                value={values.price}
                onChange={handleChange}
                className="form-control form-control-sm border border-dark"
              />

              {touched.price && errors?.price && (
                <small className="text-danger">{errors.price}</small>
              )}
            </div>

            <div className="mb-3 w-100">
              <input
                type="text"
                name="description"
                id="description"
                placeholder="Enter description"
                value={values.description}
                onChange={handleChange}
                className="form-control form-control-sm border border-dark"
              />

              {touched.description && errors?.description && (
                <small className="text-danger">{errors.description}</small>
              )}
            </div>
          </div>

         <button
  type="button"
  onClick={() => setShowCondition(!showCondition)}
  className="btn btn-sm btn-outline-info mt-2"
>
  {showCondition ? "Remove" : "Add"} Conditional Price
</button>


          {showCondition && (
            <div>
              <div className="mb-0 d-flex g-5">
                <div className="form-check">
                  <input
                    className="form-check-input "
                    type="radio"
                    name="selectedOption"
                    id="WEIGHT"
                    value="WEIGHT"
                    onChange={handleChange}
                    checked={values.selectedOption === "WEIGHT"}
                    style={{ accentColor: "red", marginLeft: "10px" }}
                  />
                  <label className="form-check-label" htmlFor="WEIGHT">
                    WEIGHT
                  </label>
                </div>

                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="selectedOption"
                    id="TOTAL_PRICE"
                    value="TOTAL_PRICE"
                    onChange={handleChange}
                    checked={values.selectedOption === "TOTAL_PRICE"}
                    style={{ accentColor: "red", marginLeft: "10px" }}
                  />
                  <label className="form-check-label" htmlFor="TOTAL_PRICE">
                    Total Price
                  </label>
                </div>
              </div>

              {values.selectedOption === "WEIGHT" ? (
                <div className="mb-3 d-flex w-100" style={{ gap: "1rem" }}>
                  <div className="flex-grow-1">
                    <input
                      type="number"
                      name="minWeight"
                      id="minWeight"
                      placeholder="Enter min weight"
                      value={values.minWeight}
                      onChange={handleChange}
                      className="form-control form-control-sm w-100"
                    />
                    {touched.minWeight && errors?.minWeight && (
                      <small className="text-danger">{errors.minWeight}</small>
                    )}
                  </div>

                  <div className="flex-grow-1">
                    <input
                      type="number"
                      name="maxWeight"
                      id="maxWeight"
                      placeholder="Enter max weight"
                      value={values.maxWeight}
                      onChange={handleChange}
                      className="form-control form-control-sm w-100"
                    />
                    {touched.maxWeight && errors?.maxWeight && (
                      <small className="text-danger">{errors.maxWeight}</small>
                    )}
                  </div>
                </div>
              ) : (
                <div className="mb-3 d-flex w-100" style={{ gap: "1rem" }}>
                  <div className="flex-grow-1">
                    <input
                      type="number"
                      name="minprice"
                      id="minprice"
                      placeholder="Enter min price"
                      value={values.minprice}
                      onChange={handleChange}
                      className="form-control form-control-sm w-100"
                    />
                    {touched.minprice && errors?.minprice && (
                      <small className="text-danger">{errors.minprice}</small>
                    )}
                  </div>

                  <div className="flex-grow-1">
                    <input
                      type="number"
                      name="maxprice"
                      id="maxprice"
                      placeholder="Enter max price"
                      value={values.maxprice}
                      onChange={handleChange}
                      className="form-control form-control-sm w-100"
                    />
                    {touched.maxprice && errors?.maxprice && (
                      <small className="text-danger">{errors.maxprice}</small>
                    )}
                  </div>
                </div>
              )}
            </div>
          )}

          <div className="checkout-preview mt-4  border p-2">
            <h5>Checkout Preview</h5>
            <div className=" rounded bg-light p-3">
              <div className="p-2 rounded d-flex justify-content-between">
                <input
                  className="form-check-input"
                  type="radio"
                  checked={true}
                  style={{ accentColor: "#FF4D6B", marginLeft: "5px" }}
                />
                <label
                  className="form-check-label"
                  htmlFor="WEIGHT"
                  style={{ marginLeft: "25px" }}
                >
                  {values.name || "Rate name"}
                </label>
                <strong>{values.price ? `${values.price}` : "FREE"}</strong>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" type="submit">
            {editingId ? "Update" : "Add"}
          </Button>
          <Button color="danger" onClick={toggleModal}>
            Cancel
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};
const SizeModal = ({
  isOpen,
  toggle,
  editingId,
  data,
  errors,
  handleChange,
  handleSubmit,
  loading,
  nextPosition
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered className="white-modal">
      <ModalHeader toggle={toggle} className="p-3">
        {editingId ? "Update" : "Add"} Size
      </ModalHeader>
      <form onSubmit={handleSubmit}>
        <ModalBody className="border pt-3">
          <div className="mb-3">
            <label htmlFor="value" className="form-label" style={{ fontWeight: 500 }}>
              Size
            </label>
            <input
              type="text"
              name="value"
              id="value"
              value={data.value}
              placeholder="Enter size"
              onChange={handleChange}
              className={`border border-dark form-control form-control-lg`}
            />
            {errors.value && !data?.value?.trim() && (
               <small className="text-danger">{errors.value}</small>
            )}
          </div>

          <div className="col-md-12 mt-4 p-0" >
            <SwitchToggle
              checked={data.isActive}
              onChange={(val) => handleChange("isActive", val)}
            />
          </div>
        </ModalBody>

        <ModalFooter>
          <Button type="submit" color="primary" disabled={loading}>
            {loading ? "Loading..." : editingId ? "Update" : "Add"}
          </Button>
          <Button color="danger" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};
const BrandModel = ({
  modalOpen,
  toggleModal,
  editingId,
  fetchCurrencies,
  updatedata,
  setEditingId,
  setupdatedata,
}) => {
  const [loading, setLoading] = useState(false);

  const initialValues = {
    name: "",
    url: "",
    image: "",
    isActive: true
  };

  const {
    errors,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    touched,
  } = useFormik({
    initialValues,
    validationSchema: brandSchema,
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);
      try {
        const response = editingId
          ? await axiosInstance.put(`/brand/${editingId}`, values)
          : await axiosInstance.post("/brand", values);

        if (response.status === 200) {
          fetchCurrencies();
          toggleModal();
          toast.success(response?.data?.message);
          resetForm();
          setEditingId(null);
          setupdatedata(null);
        }
      } catch (err) {
        toast.error(err?.response?.data?.message);
      } finally {
        setLoading(false);
      }
    },
  });

  useEffect(() => {
    if (updatedata) {
      setFieldValue("name", updatedata?.name || "");
      setFieldValue("url", updatedata?.url || "");
      setFieldValue("image", updatedata?.image || "");
      setFieldValue("isActive", updatedata?.isActive ?? true);
    }
  }, [editingId, updatedata, setFieldValue]);

  return (
    <Modal
      isOpen={modalOpen}
      toggle={toggleModal}
      centered
      className="white-modal"
    >
      <ModalHeader toggle={toggleModal}>
        {editingId ? "Update Brands" : "Add Brands"}
      </ModalHeader>
      <form onSubmit={handleSubmit}>
        <ModalBody>
          <div className="row">
            <div className="col-md-6 mb-3">
              <Label htmlFor="name" className="form-label fw-bold">
                Enter Name
              </Label>
              <Input
                type="text"
                name="name"
                id="name"
                placeholder="Enter brand name"
                className={`border border-dark  form-control form-control-sm ${touched.name && errors.name ? "is-invalid" : ""
                  }`}
                value={values.name}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              {touched.name && errors.name && (
                <div className="invalid-feedback">{errors.name}</div>
              )}
            </div>

            <div className="col-md-6 mb-3">
              <Label htmlFor="url" className="form-label fw-bold">
                Enter URL
              </Label>
              <Input
                type="text"
                name="url"
                id="url"
                placeholder="Enter brand URL"
                className={`border border-dark form-control form-control-sm ${touched.url && errors.url ? "is-invalid" : ""
                  }`}
                value={values.url}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              {touched.url && errors.url && (
                <div className="invalid-feedback">{errors.url}</div>
              )}
            </div>
          </div>

          <div className="mb-3">
            <Label htmlFor="image" className="form-label fw-bold">
              Upload Logo
            </Label>
            <Upload
              label="brand-image"
              initialImage={values.image}
              onChange={(imgUrl) => setFieldValue("image", imgUrl)}
              apiUrl={"uploads?label=brand"}

            />
          </div>


          <div className="col-md-12 mt-4 p-0">
            <SwitchToggle
              checked={values.isActive}
              onChange={(val) => setFieldValue("isActive", val)}
              activeLabel="Active"
              inactiveLabel="Inactive"
            />
          </div>
        </ModalBody>

        <ModalFooter>
          <Button type="submit" color="primary" disabled={loading}>
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Saving...
              </>
            ) : editingId ? (
              "Update"
            ) : (
              "Add"
            )}
          </Button>
          <Button color="danger" onClick={toggleModal}>
            Cancel
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};
const RoleModal = ({
  isOpen,
  toggle,
  editingId,
  data,
  errors,
  handleChange,
  handleSubmit,
  loading,
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered className="white-modal">
      <ModalHeader toggle={toggle}>
        {editingId ? "Update" : "Add"} Role
      </ModalHeader>
      <form onSubmit={handleSubmit}>
        <ModalBody>
          <div className="mb-3">
            <label htmlFor="value" className="form-label" style={{ fontWeight: 500 }}>
              Enter Role
            </label>
            <input
              type="text"
              name="name"
              id="name"
              value={data.name}
              onChange={handleChange}
              placeholder="Enter role"
              className={` border border-dark form-control form-control-lg ${errors.name && !data?.name?.trim() ? "is-invalid" : ""
                }`}
            />
            {errors.name && !data?.name?.trim() && (
              <div className="invalid-feedback">{errors.name}</div>
            )}
          </div>
        </ModalBody>

        <ModalFooter>
          <Button type="submit" color="primary" disabled={loading}>
            {loading ? "Loading..." : editingId ? "Update" : "Add"}
          </Button>
          <Button color="danger" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};
const PermissionModel = ({
  modalOpen,
  toggleModal,
  editingId,
  fetchpermission,
  updatedata,
  setEditingId,
  setupdatedata,
  role_id,
  pageData,
  permission,
  getAllPermision
}) => {
  const [loading, setLoading] = useState(false); 
  const { values, errors, touched, handleSubmit, setFieldValue, resetForm } =
    useFormik({
      initialValues: {
        role_id: role_id,
        page_id: null,
        actions: [],
      },
      validationSchema: Permissionschema,
      onSubmit: async (values) => {
        setLoading(true);
        try {
          const payload = {
            role_id:role_id,
            page_id: values.page_id.value,
            actions: values.actions?.map((a) => a.value),
          };

          const response = editingId
            ? await axiosInstance.put(`/permission/${editingId}`, payload)
            : await axiosInstance.post("/permission", payload);

          if (response.status === 200) {
            fetchpermission();
            getAllPermision()
            toggleModal();
            toast.success(response?.data?.message);
            resetForm();
            setEditingId(null);
            setupdatedata(null);
          }
        } catch (err) {
          toast.error(err?.response?.data?.message || "Something went wrong");
        } finally {
          setLoading(false);
        }
      },
    });


const existingPageIds = permission?.map((p) => p.page_id) || [];
const filteredPages = pageData?.filter(
  (p) => !existingPageIds.includes(p.id)
) || [];

const pageDataOptions = filteredPages.map((p) => ({
  label: p.pageName,
  value: p.id,
}));

  const actionOptions =
  pageData
    ?.find((p) => p.id === values.page_id?.value)
    ?.action?.map((a) => ({
      label: a,
      value: a,
    })) || [];


   useEffect(() => {
  if (updatedata && pageData?.length > 0) {

    const moduleMatch = pageData.find(
      (p) => String(p.id) === String(updatedata.page_id)
    );

    const selectedModule = moduleMatch
      ? { label: moduleMatch.pageName, value: moduleMatch.id }
      : null;

    const selectedActions =
      moduleMatch?.action
        ?.filter((a) => updatedata.actions?.includes(a))
        .map((a) => ({
          label: a,
          value: a,
        })) || [];

    setFieldValue("role_id", role_id);
    setFieldValue("page_id", selectedModule);
    setFieldValue("actions", selectedActions);
  }
}, [updatedata, pageData]);
  return (
    <Modal
      isOpen={modalOpen}
      toggle={toggleModal}
      centered
      className="white-modal"
    >
      <ModalHeader toggle={toggleModal}>
        {editingId ? "Update Permission" : "Add Permission"}
      </ModalHeader>
      <form onSubmit={handleSubmit}>
        <ModalBody>
         <div  style={{ marginTop: "-20px" }}>
          <div className="mb-3">
            <label>Page Name</label>
            <Select
              options={pageDataOptions}
             value={values.page_id || null}
              onChange={(val) => {
                setFieldValue("page_id", val);
                setFieldValue("actions", []);
              }}
              placeholder="Select Page Name"
              styles={selectStyles}
            />
            {errors.module && touched.module && (
              <small className="text-danger">{errors.module}</small>
            )}
          </div>

          <div className="mb-3">
            <label>Actions</label>
            <Select
              isMulti
              options={actionOptions}
              value={values.actions}
              placeholder="Select Action"
              onChange={(val) => setFieldValue("actions", val)}
              styles={selectStyles}
            />
            {errors.actions && touched.actions && (
              <small className="text-danger">{errors.actions}</small>
            )}
          </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button type="submit" color="primary" disabled={loading}>
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Saving...
              </>
            ) : editingId ? (
              "Update"
            ) : (
              "Add"
            )}
          </Button>
          <Button color="danger" onClick={toggleModal}>
            Cancel
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};
const HandlerModel = ({
  modalOpen,
  toggleModal,
  editingId,
  fetchCurrencies,
  updatedata,
  setEditingId,
  setupdatedata,
  roles,
}) => {
  const [loading, setLoading] = useState(false);

  const initialValues = {
    role_id: "",
    userName: "",
    email: "",
    isActive: true,
  };

  const {
    errors,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    touched,
  } = useFormik({
    initialValues,
    validationSchema: HandlerSchema,
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);
      try {
        values.role_id = values.role_id?.value;
        const response = editingId
          ? await axiosInstance.put(`/handler/${editingId}`, values)
          : await axiosInstance.post("/handler", values);

        if (response.status === 200) {
          fetchCurrencies();
          toggleModal();
          toast.success(response?.data?.message);
          resetForm();
          setEditingId(null);
          setupdatedata(null);
        }
      } catch (err) {
        toast.error(err?.response?.data?.message);
      } finally {
        setLoading(false);
      }
    },
  });

  useEffect(() => {
    if (updatedata) {
      const selectedRole = roles.find((r) => r.value === updatedata.role_id);
      setFieldValue("role_id", selectedRole || "");
      setFieldValue("userName", updatedata?.userName || "");
      setFieldValue("email", updatedata?.email || "");
      setFieldValue("isActive", updatedata?.isActive ?? true);
    }
  }, [editingId, roles, updatedata]);

  return (
    <Modal
      isOpen={modalOpen}
      toggle={toggleModal}
      centered
      className="white-modal"
    >
      <ModalHeader toggle={toggleModal} className="mb-0">
        {editingId ? "Update User" : "Add User"}
      </ModalHeader>
      <form onSubmit={handleSubmit}>
 <ModalBody>
  <div style={{ marginTop: "-20px" }}>
          <div className="mb-3">
            <label>Select Role</label>
            <Select
              options={roles}
              value={values.role_id}
              onChange={(val) => setFieldValue("role_id", val)}
              styles={selectStyles}
            />
            {errors.role_id && touched.role_id && (
              <small className="text-danger">{errors.role_id}</small>
            )}
          </div>

          <div className="mb-3">
            <Label htmlFor="userName" className="form-label fw-bold">
              Enter Username
            </Label>
            <Input
              type="text"
              name="userName"
              id="userName"
              className={`border border-dark  form-control form-control-sm `}
              value={values.userName}
              placeholder="Username"
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {touched.userName && errors.userName && (
              <small className="text-danger">{errors.userName}</small>
            )}
          </div>

          <div className="mb-3">
            <Label htmlFor="email" className="form-label fw-bold">
              Enter Email
            </Label>
            <Input
              type="text"
              name="email"
              id="email"
              className={`border border-dark  form-control form-control-sm`}
              value={values.email}
              placeholder="Email"
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {touched.email && errors.email && (
               <small className="text-danger">{errors.email}</small>
            )}
          </div>


          <div className="col-md-12 mt-4 p-0">
            <SwitchToggle
              checked={values.isActive}
              onChange={(val) => setFieldValue("isActive", val)}
              activeLabel="Active"
              inactiveLabel="Inactive"
            />
          </div>
</div>
        </ModalBody>
        <ModalFooter>
          <Button type="submit" color="primary" disabled={loading}>
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Saving...
              </>
            ) : editingId ? (
              "Update"
            ) : (
              "Add"
            )}
          </Button>
          <Button color="danger" onClick={toggleModal}>
            Cancel
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};
const ShippingPartnerModal = ({
  modalOpen,
  toggleModal,
  editingId,
  fetchshipping,
  updatedata,
  setEditingId,
  setupdatedata,
}) => {
  const [loading, setLoading] = useState(false);

  const initialValues = {
    name: "",
    isActive: true,
  };

  const {
    errors,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    touched,
  } = useFormik({
    initialValues,
    validationSchema: ShippingPartnerSchema,
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);
      try {
        const response = editingId
          ? await axiosInstance.put(`/shipping-partner/${editingId}`, values)
          : await axiosInstance.post("/shipping-partner", values);

        if (response.status === 200) {
          fetchshipping();
          toggleModal();
          toast.success(response?.data?.message);
          resetForm();
          setEditingId(null);
          setupdatedata(null);
        }
      } catch (err) {
        toast.error(err?.response?.data?.message);
      } finally {
        setLoading(false);
      }
    },
  });

  useEffect(() => {
    if (updatedata) {
      setFieldValue("name", updatedata?.name || "");
      setFieldValue("isActive", updatedata?.isActive ?? true);
    }
  }, [editingId, updatedata, setFieldValue]);

  return (
    <Modal
      isOpen={modalOpen}
      toggle={toggleModal}
      centered
      className="white-modal"
      size="md"
    >
      <ModalHeader toggle={toggleModal}>
        {editingId ? "Update Shipping Partner" : "Add Shipping Partner"}
      </ModalHeader>
      <form onSubmit={handleSubmit}>
        <ModalBody>
          <div className="row" style={{ marginTop: "-20px" }}>
            <div className="col-md-12 mb-3">
              <Label htmlFor="code" className="form-label fw-bold">
                Shipping Partner
              </Label>
              <Input
                type="text"
                name="name"
                id="name"
                placeholder="Enter name "
                className={` border border-dark form-control form-control-sm`}
                value={values.name}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              {touched.name && errors.name && (
                <small className="text-danger">{errors.name}</small>
              )}
            </div>



            <div className="col-md-12">
              <SwitchToggle
                checked={values.isActive}
                onChange={(val) => setFieldValue("isActive", val)}
                activeLabel="Active"
                inactiveLabel="Inactive"
              />
            </div>


          </div>
        </ModalBody>
        <ModalFooter>
          <Button type="submit" color="primary" disabled={loading}>
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Saving...
              </>
            ) : editingId ? (
              "Update"
            ) : (
              "Add"
            )}
          </Button>
          <Button color="danger" onClick={toggleModal}>
            Cancel
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};
const MenuImageModal = ({
  modalOpen,
  toggleModal,
  editingId,
  fetchData,
  updatedata,
  setEditingId,
  position,
  setupdatedata,
  size
}) => {
  const [loading, setLoading] = useState(false);
  const initialValues = {
    url: "",
    image: "",
    position: position || 1,
    menu_id: null,
    isActive: true,
  };

  const {
    errors,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    touched,
  } = useFormik({
    initialValues,
    validationSchema: menuImageSchema,
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);
      try {
        const response = editingId
          ? await axiosInstance.put(`/menu-image/${editingId}`, values)
          : await axiosInstance.post("/menu-image", values);

        if (response.status === 200) {
          fetchData();
          toggleModal();
          toast.success(response?.data?.message);
          resetForm();
          setEditingId(null);
          setupdatedata(null);
        }
      } catch (err) {
        toast.error(err?.response?.data?.message);
      } finally {
        setLoading(false);
      }
    },
  });
  useEffect(() => {
    if (updatedata?.id) {
      setFieldValue("url", updatedata?.code || "");
      setFieldValue("image", updatedata?.image || "");
      setFieldValue("isActive", updatedata?.isActive ?? true);
    }
    setFieldValue("position", updatedata?.position ?? position);
    setFieldValue("menu_id", updatedata?.menu_id || null);
  }, [editingId, updatedata, setFieldValue]);



  return (
    <Modal
      isOpen={modalOpen}
      toggle={toggleModal}
      centered
      className="white-modal"
      size="md"
    >
      <ModalHeader toggle={toggleModal}>
        {editingId ? "Update Menu Image" : "Add Menu Image"}
      </ModalHeader>
      <form onSubmit={handleSubmit}>
        <ModalBody>
          <div className="row" style={{ marginTop: "-20px" }}>
            <div className="col-md-6 mb-3">
              <Label htmlFor="url" className="form-label fw-bold">
                Url
              </Label>
              <Input
                type="text"
                name="url"
                id="url"
                placeholder="Enter redirect url"
                className={` border border-dark form-control form-control-sm ${touched.url && errors.url ? "is-invalid" : ""}`}
                value={values.url}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              {touched.url && errors.url && (
                <div className="text-danger">{errors.url}</div>
              )}
            </div>


            <div className="col-md-6 mb-3">
              <Label htmlFor="position" className="form-label fw-bold">
                Position
              </Label>
              <Input
                type="number"
                name="position"
                id="position"
                placeholder="Enter Position"
                className={` border border-dark form-control form-control-sm ${touched.position && errors.position ? "is-invalid" : ""}`}
                value={values.position}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              {touched.position && errors.position && (
                <div className="text-danger">{errors.position}</div>
              )}
            </div>

            <div className="col-md-6 mt-3">
               <label className="form-label fw-bold">{`Image Size ${size}`}</label>
              <Upload
                label="menu-image"
                initialImage={values.image}
                onChange={(imgUrl) => setFieldValue("image", imgUrl)}
                apiUrl={"uploads?label=menu"}

              />

              {touched.image && errors.image && (
                <div className="text-danger">{errors.image}</div>
              )}
            </div>

            <div className="col-md-12 mt-4">
              <SwitchToggle
                checked={values.isActive}
                onChange={(val) => setFieldValue("isActive", val)}
                activeLabel="Active"
                inactiveLabel="Inactive"
              />
            </div>


          </div>
        </ModalBody>
        <ModalFooter>
          <Button type="submit" color="primary" disabled={loading}>
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Saving...
              </>
            ) : editingId ? (
              "Update"
            ) : (
              "Add"
            )}
          </Button>
          <Button color="danger" onClick={toggleModal}>
            Cancel
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};
export {
  ShippingzoneModel,
  ShippingRateModel,
  SizeModal,
  BrandModel,
  RoleModal,
  PermissionModel,
  HandlerModel,
  ShippingPartnerModal,
  MenuImageModal,
  CurrencyModal
};
